import { render, staticRenderFns } from "./FarmsList.vue?vue&type=template&id=52c350f3&scoped=true&lang=pug&"
import script from "./FarmsList.vue?vue&type=script&lang=ts&"
export * from "./FarmsList.vue?vue&type=script&lang=ts&"
import style0 from "./FarmsList.vue?vue&type=style&index=0&id=52c350f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c350f3",
  null
  
)

export default component.exports